import styled from '@emotion/styled'

export const FailedSaveMessageContainer = styled('div')({
  marginTop: '2rem',
})
